import { RepoStoreFocusType } from '~/app/(dash)/[team-slug]/(repo)/[repo-slug]/(editor)/explore/components/repo-store'
import { tabContentId } from '~/app/(dash)/[team-slug]/(repo)/[repo-slug]/(editor)/tab-content/wrapper'

export const getDomHasSelectedText = () => {
  // prevent copy of block if user has some text selected
  const selection = window.getSelection()
  if (selection && selection.rangeCount > 0) {
    const range = selection.getRangeAt(0)

    return range.startOffset !== range.endOffset
  }
}

export const getEditorElement = () => {
  const editor = document.getElementById(tabContentId)
  if (!editor) throw new Error('tab content not found')

  return {
    editor,
    focusedElement: document.activeElement,
    focusIsInsideEditor:
      editor.contains(document.activeElement) ||
      document?.activeElement instanceof HTMLBodyElement,
  }
}

export const isScrolledIntoView = (el: HTMLElement, partial?: boolean) => {
  const rect = el.getBoundingClientRect()
  const elemTop = rect.top
  const elemBottom = rect.bottom

  if (partial) {
    // Partially visible elements return true:
    return elemTop < window.innerHeight && elemBottom >= 0
  } else {
    // Only completely visible elements return true:
    return elemTop >= 0 && elemBottom <= window.innerHeight
  }
}

export const getShouldPreventCopyBlock = (
  focusedElement: Element | null,
  repoStoreFocus?: RepoStoreFocusType
) => {
  if (!focusedElement || !(focusedElement instanceof HTMLElement)) return false
  if (typeof window === 'undefined' || !window) return false

  const isFocusingText = (window.getSelection() ?? '').toString().length > 0
  if (isFocusingText) return true

  const focusIsInDialogTrigger = focusedElement['ariaHasPopup'] === 'dialog'
  if (focusIsInDialogTrigger) return true

  const focusIsInListBlock =
    focusedElement.role === 'gridcell' || focusedElement.nodeName === 'CANVAS'
  if (focusIsInListBlock) return true

  return Boolean(
    repoStoreFocus === 'block:value' ||
      focusedElement.getAttribute('contenteditable') ||
      (['INPUT', 'TEXTAREA', 'BUTTON', 'A', 'SPAN'].includes(
        focusedElement.tagName
      ) &&
        (focusedElement.dataset.blockId ||
          focusedElement.dataset.selectorSearchInput))
  )
}
